import type { UserProfile } from '@domain/models/user'

function normalizeEmail(email: string) {
  return email.trim().toLowerCase()
}

function readString(data: Record<string, unknown>, ...keys: string[]) {
  for (const key of keys) {
    const value = data[key]
    if (typeof value === 'string') {
      return value
    }
  }
  return undefined
}

function readBoolean(data: Record<string, unknown>, ...keys: string[]) {
  for (const key of keys) {
    const value = data[key]
    if (typeof value === 'boolean') {
      return value
    }
  }
  return undefined
}

export class UserConverter {
  public static fromFirestore(uid: string, data: Record<string, unknown>): UserProfile {
    const uidFromDocument = readString(data, 'uid')
    const fullName = readString(data, 'fullName', 'profile_slug')
    const profileSlug = readString(data, 'profile_slug', 'fullName')

    return {
      uid: uidFromDocument ?? uid,
      email: readString(data, 'email') ?? '',
      avatarUrl: readString(data, 'avatarUrl', 'photo_url'),
      fullName,
      public_full_name: readString(data, 'public_full_name'),
      short_bio: readString(data, 'short_bio'),
      public_contact_email: readString(data, 'public_contact_email'),
      profile_slug: profileSlug,
      isAdmin: readBoolean(data, 'isAdmin', 'admin'),
    }
  }

  public static toFirestore(user: UserProfile): Record<string, unknown> {
    const payload: Record<string, unknown> = {
      uid: user.uid,
      email: normalizeEmail(user.email),
    }

    if (user.avatarUrl !== undefined) {
      payload.photo_url = user.avatarUrl
    }
    if (user.fullName !== undefined || user.profile_slug !== undefined) {
      payload.profile_slug = user.fullName ?? user.profile_slug
    }
    if (user.isAdmin !== undefined) {
      payload.admin = user.isAdmin
    }

    return payload
  }

  public static partialToFirestore(updates: Partial<UserProfile>): Record<string, unknown> {
    const payload: Record<string, unknown> = {}

    if (updates.uid !== undefined) {
      payload.uid = updates.uid
    }
    if (updates.email !== undefined) {
      payload.email = normalizeEmail(updates.email)
    }
    if (updates.avatarUrl !== undefined) {
      payload.photo_url = updates.avatarUrl
    }
    if (updates.fullName !== undefined || updates.profile_slug !== undefined) {
      payload.profile_slug = updates.fullName ?? updates.profile_slug
    }
    if (updates.isAdmin !== undefined) {
      payload.admin = updates.isAdmin
    }

    return payload
  }
}
